import update from 'immutability-helper';

import { DATA_RECEIVED, FETCH_DATA } from '../actions/trades';

const initialState = {
    columns: [
        'ID',
        'TIME',
        'PRICE',
        'VOLUME',
        'SELLER',
        'BUYER',
        'TYPE',
    ],
    limit: 5,
};

export default function trades(state = initialState, action) {
    switch (action.type) {
    case DATA_RECEIVED:
        if (action.data) {
            const symbol = state[action.meta.symbol] || {};
            const currentTrades = symbol.trades || [];

            for (const trade in currentTrades) {
                if (
                    currentTrades.hasOwnProperty(trade) &&
                    currentTrades[trade].ID === action.data.values.ID
                ) {
                    return state;
                }
            }

            return Object.assign({}, state, {
                [action.meta.symbol]: {
                    trades: update(currentTrades, {
                        $unshift: [action.data.values],
                    }),
                },
            });
        }

        return state;
    case FETCH_DATA.REQUEST:
        return Object.assign({}, state, {
            [action.meta.symbol]: Object.assign({},
                state[action.meta.symbol] || [],
                { isLoading: true },
            ),
        });
    case FETCH_DATA.SUCCESS:
        if (action.payload) {
            return Object.assign({}, state, {
                [action.meta.symbol]: {
                    trades: action.payload.map(
                        trade => trade.values
                    ),
                    isLoading: false,
                },
            });
        }
        return state;
    case FETCH_DATA.FAILURE:
        return {
            [action.meta.symbol]: { isLoading: false },
        };

    default:
        return state;
    }
}



/** WEBPACK FOOTER **
 ** /src/shared/redux/trades.js
 **/